<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()">Settings</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <div scrollY="true" style="height: 680px">

        <ion-list>
            <ion-item-divider color="tertiary">
                Efficiency Settings
            </ion-item-divider>

            <ion-item [disabled]=vb.disabled detail="true" data-test="dealership" href="javascript:;"
                    (click)="onDealershipClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Dealership Profile</span><br />
                    <span class="line2">Where is the dealership located?</span>
                </ion-label>
            </ion-item>

            <ion-item [disabled]=vb.disabled detail="true" data-test="users" href="javascript:;"
                    (click)="onUsersClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Users</span><br />
                    <span class="line2">Who will be using ShuttleNomix?</span>
                </ion-label>
            </ion-item>

            <ion-item [disabled]=vb.disabled detail="true" data-test="shuttles" href="javascript:;"
                    (click)="onShuttlesClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Shuttles</span><br />
                    <span class="line2">Which shuttles will be used?</span>
                </ion-label>
            </ion-item>

            <ion-item [disabled]=vb.disabled detail="true" data-test="serviceAreas" href="javascript:;"
                    (click)="onServiceAreasClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Service Areas</span><br />
                    <span class="line2">Which zipcodes do you service?</span>
                </ion-label>
            </ion-item>

            <ion-item-divider color="tertiary">
                Customer Communication Settings
            </ion-item-divider>

            <ion-item [disabled]=vb.disabled detail="true" data-test="ticketCreated" href="javascript:;"
                    (click)="onTicketCreatedClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Ticket Created Message</span><br />
                    <span class="line2">Message sent to ticket holder when ticket is created.</span>
                </ion-label>
            </ion-item>

            <ion-item [disabled]=vb.disabled detail="true" data-test="dropoffAllAboard" href="javascript:;"
                    (click)="onDropoffAllAboardClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">All Aboard Message</span><br />
                    <span class="line2">Message sent to pending ticket holders notifying them the 
                        shuttle is about to leave.</span>
                </ion-label>
            </ion-item>

<!--             
            <ion-item [disabled]=vb.disabled id="dropoffApproaching" detail="true" routerLink="/dropoffApproaching" routerDirection="forward">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Approaching Dropoff Message</span><br />
                    <span class="line2">Message sent to passenger just prior to dropoff.</span>
                </ion-label>
            </ion-item>
-->

            <ion-item [disabled]=vb.disabled detail="true" data-test="dropoffCompleted" href="javascript:;"
                    (click)="onDropoffCompletedClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Dropoff Completed Message</span><br />
                    <span class="line2">Message sent to passenger when the ride is over.</span>
                </ion-label>
            </ion-item>
    
            <ion-item [disabled]=vb.disabled detail="true" data-test="pickupApproaching" href="javascript:;"
                    (click)="onPickupApproachingClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Approaching Pickup Message</span><br />
                    <span class="line2">Message sent to ticket holder saying we will be there soon.</span>
                </ion-label>
            </ion-item>
    
            <ion-item [disabled]=vb.disabled detail="true" data-test="pickupArrived" href="javascript:;"
                    (click)="onPickupArrivedClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Pickup Arrived Message</span><br />
                    <span class="line2">Message sent to ticket holder when the shuttle arrives at the pickup location.</span>
                </ion-label>
            </ion-item>
    
            <ion-item [disabled]=vb.disabled detail="true" data-test="pickupCompleted" href="javascript:;"
                    (click)="onPickupCompletedClick()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Pickup Completed Message</span><br />
                    <span class="line2">Message sent to passenger when the ride is over.</span>
                </ion-label>
            </ion-item>

            <ion-item-divider color="tertiary">
                Other Settings
            </ion-item-divider>

            <ion-item [disabled]=vb.disable detail="true" data-test="cacheLoginCreds" href="javascript:;"
                    (click)="onCacheLoginCreds()">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Cache Login Credentials</span><br />
                    <span class="line2">This will make logging in easier.</span>
                </ion-label>
            </ion-item>
    
            <!-- 
            <ion-item [disabled]=vb.disabled *n gI f="onDevice" detail="true" id="btnChannels" routerDirection="forward" routerLink="/channels/"> -->                    <!-- <ion-item [disabled]=vb.disabled detail="true" id="btnChannels" routerDirection="forward" routerLink="/channels/">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Channels</span><br />
                    <span class="line2">Access the Production, Beta or Alpha Channel.</span>
                </ion-label>
            </ion-item>
            -->
        </ion-list>
    </div>
</ion-content>